
import { initialState } from './initialState';

export default function (state = initialState, action = {}) {
  switch (action.type) {
    case 'GET_REFERRAL_LOADING':
      return {
        ...state,
        isLoading: true,
        success: false,
        error: false,
      };

    case 'GET_REFERRAL_SUCCESS':
      return {
        ...state,
        isLoading: false,
        success: true,
        get_referral_Data: action.payload.data,
        error: false,
      };

    case 'GET_REFERRAL_ERROR':
      return {
        ...state,
        isLoading: false,
        success: false,
        error: action.payload.response ? action.payload.response.data : action.payload.data,
      };
   
    default:
      return {
        ...state,
      };
  }
}
